import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import DistrictCell from "./Components/DistrictCell";
import YesNoCell from "./Components/YesNoCell";

const SummaryWrapper = styled.div`
  padding-top: 14px;
  padding-bottom: 12px;
  font-weight: 300;

  @media screen and (min-width: 540px) {
    padding-top: 22px;
    font-size: 18px;
    max-width: 580px;
  }
`;

const SubNote = styled.div`
  margin-top: 8px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.64);
  font-size: 14px;

  @media screen and (min-width: 540px) {
    font-size: 16px;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 300;
  line-height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);

  @media screen and (min-width: 540px) {
    line-height: 34px;
  }
`;

const Bold = styled.span`
  font-weight: 500;
`;

const ExpandRow = styled.div`
  margin-top: 8px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media screen and (min-width: 540px) {
    font-size: 18px;
  }
`;

const CaretWrapper = styled.span`
  padding-right: 14px;
`;

const Summary = ({ total, onExpandHouse, onExpandSenate }) => (
  <SummaryWrapper>
    <Row>
      <DistrictCell></DistrictCell>
      <YesNoCell>Support</YesNoCell>
      <YesNoCell>Oppose</YesNoCell>
    </Row>
    <Row>
      <DistrictCell>
        <Bold>Florida Total</Bold>
      </DistrictCell>
      <YesNoCell>{total.YES.toLocaleString()}</YesNoCell>
      <YesNoCell>{total.NO.toLocaleString()}</YesNoCell>
    </Row>
    <SubNote>Includes stances from verified Florida voters only.</SubNote>
    <ExpandRow onClick={onExpandHouse}>
      <CaretWrapper>
        <FontAwesomeIcon icon={faCaretRight} />
      </CaretWrapper>
      FL House Districts
    </ExpandRow>
    <ExpandRow onClick={onExpandSenate}>
      <CaretWrapper>
        <FontAwesomeIcon icon={faCaretRight} />
      </CaretWrapper>
      FL Senate Districts
    </ExpandRow>
  </SummaryWrapper>
);

Summary.propTypes = {
  total: PropTypes.shape({ YES: PropTypes.number, NO: PropTypes.number }),
  onExpandHouse: PropTypes.func,
  onExpandSenate: PropTypes.func,
};

export default Summary;
